<template>
  <div>
    <v-row class="remove-print">
      <v-col cols="12" md="6" sm="6">
        <v-text-field
          v-model="formData.kv"
          label="KV"
          outlined
          clearable
          dense
          @keydown.enter="generateInfoBL"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" sm="6">
        <v-text-field
          v-model="formData.kc"
          label="KC"
          outlined
          clearable
          dense
          autofocus
          @keydown.enter="generateInfoBLByContainer"
        ></v-text-field>
      </v-col>
    </v-row>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading Data
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h1 class="report-title mr-5">PACKING LIST CONTAINER</h1>
        <h3 class="my-auto" v-if="data.vessel">
          Kode Vessel: <b>{{ data.vessel.kv }}</b> /
          <b>{{ data.vessel.nama_kapal }}</b> - <b>{{ data.vessel.voy }}</b>
        </h3>
        <h3 class="my-auto" v-else>Kode Vessel: -</h3>
      </div>
      <div
        class="content mt-2 mb-5"
        v-for="container in data.containers"
        :key="container.id"
      >
        <div class="head">
          <table style="width: 100%">
            <tr>
              <td width="20%">NOMOR CONTAINER</td>
              <td width="2%">:</td>
              <td>{{ container.no_container }} / {{ container.kc }}</td>
              <td></td>
              <td width="20%">TANGGAL STUFFING</td>
              <td width="2%">:</td>
              <td>{{ formatDate(container.tgl_stuffing) }}</td>
            </tr>
            <tr>
              <td width="20%">NOMOR SEAL</td>
              <td width="2%">:</td>
              <td>{{ container.no_seal }}</td>
              <td></td>
              <td width="20%">TANGGAL BONGKAR</td>
              <td width="2%">:</td>
              <td></td>
            </tr>
            <tr>
              <td width="20%">EX KM</td>
              <td width="2%">:</td>
              <td v-if="data.vessel">
                {{ data.vessel.nama_kapal }} / {{ data.vessel.voy }}
              </td>
              <td v-else>-</td>
              <td></td>
              <td width="20%">TOTAL TON / M3</td>
              <td width="2%">:</td>
              <td>
                {{ totalTonPerContainer(container) }} /
                {{ totalM3PerContainer(container) }}
              </td>
            </tr>
          </table>
        </div>

        <br />

        <table width="100%" class="table-border">
          <thead>
            <th class="text-center" width="15%">NO TTB / KODE TTB</th>
            <th class="text-center" width="20%">KOLI DLM CONTAINER</th>
            <th class="text-center" width="15%">PENERIMA</th>
            <th class="text-center" width="15%">PENGIRIM</th>
            <th class="text-center" width="35%" colspan="2">
              KETERANGAN BARANG
            </th>
          </thead>
          <tbody>
            <tr v-for="containerDetil in container.container_detil">
              <td class="text-center">
                {{ containerDetil.ttb.nottb }} /
                {{ containerDetil.ttb.kodettb }}
              </td>
              <td class="text-center">{{ containerDetil.koli_in }}</td>
              <td v-if="containerDetil.ttb.penerima_detil">
                {{ containerDetil.ttb.penerima_detil.nama || "-" }} <br />
                {{ containerDetil.ttb.penerima_detil.telp || "-" }}
              </td>
              <td v-else>-</td>
              <td v-if="containerDetil.ttb.pengirim_detil">
                {{ containerDetil.ttb.pengirim_detil.nama || "-" }}
              </td>
              <td v-else>-</td>
              <td class="box">
                <ul>
                  <li
                    v-for="ttbDetil in containerDetil.ttb.ttb_detil"
                    :key="ttbDetil.id"
                  >
                    {{ ttbDetil.koli }} {{ ttbDetil.packing }}
                    {{ ttbDetil.nama_barang }}
                  </li>
                </ul>
              </td>
              <td class="total">
                <p class="my-0">
                  Total M3: {{ totalM3(containerDetil.ttb.ttb_rinci) }}
                </p>
                <p class="my-0">
                  Total Ton: {{ totalTon(containerDetil.ttb.ttb_rinci) }}
                </p>
              </td>
            </tr>
            <tr>
              <td></td>
              <td colspan="5">KEADAAN SAAT PEMBONGKARAN :</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        kv: "",
        kc: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    tgl_berangkat() {
      let date = new Date(this.data.tgl_berangkat);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  watch: {
    "formData.kc"(val) {
      if (val) {
        this.formData.kc = val.toUpperCase();
      }
    },
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async generateInfoBL() {
      this.state.loading = true;

      await axios
        .get(`laporan/packing-list?kv=${this.formData.kv}`)
        .then(res => {
          if (!res.data.vessel) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    async generateInfoBLByContainer() {
      this.state.loading = true;

      await axios
        .get(
          `laporan/packing-list-by-container?kv=${this.formData.kv}&kc=${this.formData.kc}`
        )
        .then(res => {
          if (res.data.containers.length) {
            this.state.noData = false;
            this.data = res.data;
          } else {
            this.state.noData = true;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    totalTonPerContainer(data) {
      let total = 0;

      data.container_detil.forEach(containerDetil => {
        total += this.totalTon(containerDetil.ttb.ttb_rinci);
      });

      return total;
    },
    totalM3PerContainer(data) {
      let total = 0;

      data.container_detil.forEach(containerDetil => {
        total += this.totalM3(containerDetil.ttb.ttb_rinci);
      });

      return total;
    },
    totalM3(data) {
      let total = 0;

      data.forEach(el => {
        total += el.m3;
      });

      return parseFloat(total.toFixed(2));
    },
    totalTon(data) {
      let total = 0;

      data.forEach(el => {
        total += el.ton;
      });

      return parseFloat(total.toFixed(2));
    },
    formatDate(val) {
      let date = new Date(val);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.head {
  display: flex;
}

.mr-10 {
  margin-right: 15rem;
}

td.box {
  padding: 0 5px;
  border: 1px solid black;
}

table {
  border-collapse: collapse;
  font-size: small;
}

tr.separator {
  border-bottom: 1px solid black;
  padding-top: 2px;
  padding-bottom: 2rem;
}

.total {
  vertical-align: top;
  padding-left: 1rem;
}

.table-border,
.table-border th,
.table-border td {
  border: 2px solid black;
  border-collapse: collapse;
}

.table-border td {
  padding: 2px;
}

@page {
  size: auto;
}
</style>
